import $ from 'jquery';

var $navigationLayer = $('#navigation-layer'),
    $menus = $navigationLayer.find('.menu-container'),
    $closeMenuButton = $menus.find('.menu-close'),
    $overlay = $('.menu-overlay');

$('#menu-level-1 a').on('click', function (e) {

    $('#menu-level-3 .collapse').collapse('hide');

    return true;
});

$menus.on('show.bs.collapse', onShowMenu);
$menus.on('hide.bs.collapse', onHideMenu);
$closeMenuButton.on('click touchstart', onCloseButtonClick);
$('body').on('mouseup touchend', onClickBody);

/**
 * Fired when the menu-container is shown.
 *
 * @event onShowMenu
 */
function onShowMenu(event) {
    var $target = $(event.target);

    if($target.hasClass('menu-container')) {
        showOverlay();
    }
}

/**
 * Fired when the menu-container is hidden.
 *
 * @event onHideMenu
 */
function onHideMenu(event) {
    var $target = $(event.target);

    if($target.hasClass('menu-container')) {
        hideOverlay();
    }
}

/**
 * Fired when the close button is clicked.
 *
 * @event onCloseButtonClick
 * @param {jQuery.Event} event
 */
function onCloseButtonClick(event) {
    event.preventDefault();

    closeMenu();
}

/**
 * Fired when the mouse clicks outside the navigation layer.
 *
 * @event onClick
 * @param {jQuery.Event} event
 */
function onClickBody(event) {
    var target = event.target;

    if (!$navigationLayer.is(target) && $navigationLayer.has(target).length === 0) {
        closeMenu();
    }
}

/**
 * Closes / hides the menu.
 *
 * @public
 * @method closeMenu
 */
function closeMenu() {
    var $activeMenu = $menus.filter('.show'),
        menuId = $activeMenu.attr('id'),
        $associatedLink = $('.navigation .nav-link[data-target="#' + menuId + '"]');

    $associatedLink.trigger('click');
}

/**
 * Opens the overlay
 */
function showOverlay() {
    var $renderElement = $('.page');

    if(!$overlay || $overlay.length === 0){
        $overlay = generateOverlay();
        $overlay.appendTo($renderElement);
    }

    $overlay.addClass('is-open');
}

/**
 * Hides the overlay
 */
function hideOverlay() {
    if(!$overlay || $overlay.length === 0){
        return
    }

    $overlay.removeClass('is-open');

    $overlay.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
        $overlay.prop('style', '').remove();
        $overlay = null;
    });
}

/**
 * Method which creates the necessary DOM elements for the overlay
 *
 * @returns {jQuery}
 * @private
 */
function generateOverlay() {
    var $overlayTemplate = $('<div>', {
        'class': [
            'menu-overlay', 'is-open'
        ].join(' ')
    });

    return $overlayTemplate;
}